import React from 'react';
import PropTypes from 'prop-types';
import { Logo } from '../../../components/shared';

const OauthLayout = ({ children }) => (
  <div className="container-md vh-100 d-flex flex-column align-items-center justify-content-center w-100">
    {/* browser only */}
    <div className="d-none d-md-flex row" style={{ paddingTop: '4rem', paddingBottom: '2rem' }}>
      <Logo />
    </div>
    <div className="d-none d-md-flex row" style={{ paddingTop: '4rem', paddingBottom: '2rem' }}>
      <></>
    </div>

    {/* mobile */}
    <div className="d-flex d-md-none bg-light card flex-column justify-content-center">
      {children}
    </div>

    {/* browser */}
    <div className="d-none d-md-flex bg-lighter col-5 card p-4">{children}</div>
  </div>
);

OauthLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

export default OauthLayout;
